import CustomLinkButton from "GeneralComponents/CustomLinkButton";
import ComponentImage from "GeneralComponents/ComponentImage";
import LimitedContent from "GeneralComponents/LimitedContent";
import CarouselItem, { ApiListContentRowsMeppaing } from "../Carousel.interface"
import { MediaItem } from "Interfaces/general.interface";

import "./Links.min.css";

interface ICarouselLinkItem extends CarouselItem {
    contentRows?: ApiListContentRowsMeppaing[]
}

type Props = {
    carouselItem: ICarouselLinkItem;
    getLinksHasImages: () => boolean;
    isApiList: boolean;
    dir: string;
}

const LinksCarouselItem: React.FC<Props> = ({ carouselItem, getLinksHasImages, isApiList, dir }) => {

    const { content, icon, image, index, title, url, link, mobileImage, richDescription } = carouselItem;
    const contentRows = carouselItem.contentRows || [];

    const iconClass = (icon) + ' minisite-font-36 pallete-color';

    const contentHeight = (url || (link && link.url)) ? "" : "mst-card-content-full-height";

    const linksCarouselHasImages = getLinksHasImages();


    return (

        <div className={`item mst-carousel-item d-flex overflow-hidden ${isApiList ? 'api-list-item-card' : ''}`} >

            <div className="mst-card mst-box-item d-flex flex-column px-3 px-md-4" >

                <div className="mb-2 mb-md-4">

                    <div className="mb-4">
                        {
                            ((linksCarouselHasImages && image.url) || isApiList) &&
                            <ComponentImage
                                image={image}
                                imageClass="mx-auto"
                                mobileImage={mobileImage}
                                mobileImageClass=""
                                wrapperDivClass="" />

                        }
                        {
                            !linksCarouselHasImages &&
                            <i className={iconClass}></i>
                        }

                    </div>

                    <div className={"mst-card-content content-txt overflow-hidden px-4 px-lg-0 " + contentHeight}>

                        {
                            title &&
                            <>
                                <h3 className="mb-3">{title}</h3>
                                <div className=" mx-auto mx-md-0 mb-2 hr"></div>
                            </>
                        }

                        <div className="mst-link-carousel-content" >

                            <LimitedContent htmlContent={richDescription + content}></LimitedContent>

                            {
                                isApiList ?

                                    <ul style={{ listStyleType: 'none' }}
                                        className="mst-link-carousel-api-content-rows p-0">

                                        {
                                            contentRows.map((cr, idx) => {
                                                // Display icon / space if first row has icon
                                                const showIconWrrapper = contentRows.length > 0 && !!contentRows[0].icon;

                                                return cr.content ?
                                                    <li className="api-item-row" key={idx}>
                                                        {
                                                            showIconWrrapper &&
                                                            <div className="api-content-row-icon-wrapper d-inline-flex align-items-end">
                                                                {cr.icon && <i aria-hidden="true" className={`${cr.icon} txt-pallete-color mx-1`}></i>}
                                                            </div>
                                                        }
                                                        {cr.title && <span className="row-title">{cr.title}: </span>}
                                                        {cr.content && <span className="row-content mx-1">{cr.content}</span>}
                                                    </li>
                                                    : <></>

                                            })
                                        }

                                    </ul> : <></>
                            }

                        </div>

                    </div>

                </div>

                {
                    (url || link.url) &&
                    <div className={`align-bottom ${isApiList ? 'px-4 px-lg-0 pb-3' : ''}`} >

                        <CustomLinkButton
                            title={title}
                            pageUrl={url}
                            link={link}
                            isBtn={true}
                            btnClass={"btn btn-outline-primary mst-btn mst-btn-round px-auto"}
                            linkClass={""}
                            dir={dir}
                            linkIcon={true} />

                    </div>
                }

            </div>

        </div>

    );
}

export default LinksCarouselItem;
